import { render, staticRenderFns } from "./vodaNoProgn.vue?vue&type=template&id=71004235"
import script from "./vodaNoProgn.vue?vue&type=script&lang=js"
export * from "./vodaNoProgn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports